import React from 'react';
import { Heart, Users, Clock } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent } from './ui/card';

const About = () => {
  const { t } = useTranslation();

  return (
    <section id="about" className="py-20 bg-gradient-to-b from-white to-pink-50/30">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('about.title')}
          </h2>
          <p className="text-xl text-gray-600">
            {t('about.subtitle')}
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center mb-12">
          <div className="space-y-6">
            <p className="text-lg text-gray-700 leading-relaxed">
              {t('about.description')}
            </p>
            
            <div className="bg-gradient-to-br from-pink-100 to-purple-100 rounded-2xl p-6">
              <h3 className="font-semibold text-gray-900 mb-3 flex items-center gap-2">
                <Heart className="w-5 h-5 text-pink-600" />
                {t('about.missionTitle')}
              </h3>
              <p className="text-gray-700">
                {t('about.mission')}
              </p>
            </div>
          </div>

          <div className="rounded-3xl overflow-hidden shadow-2xl">
            <img 
              src="https://customer-assets.emergentagent.com/job_nido-pantano/artifacts/7txcqclc_inbound6008576276672626113.jpg"
              alt="Crescere insieme scoprire con gioia"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          <Card className="border-0 shadow-lg hover:shadow-xl transition-shadow bg-white">
            <CardContent className="p-6">
              <div className="w-12 h-12 bg-gradient-to-br from-pink-100 to-purple-100 rounded-full flex items-center justify-center mb-4">
                <Heart className="w-6 h-6 text-pink-600" />
              </div>
              <h3 className="font-semibold text-lg text-gray-900 mb-2">
                {t('about.feature1Title')}
              </h3>
              <p className="text-gray-600">
                {t('about.feature1Desc')}
              </p>
            </CardContent>
          </Card>
          <Card className="border-0 shadow-lg hover:shadow-xl transition-shadow bg-white">
            <CardContent className="p-6">
              <div className="w-12 h-12 bg-gradient-to-br from-pink-100 to-purple-100 rounded-full flex items-center justify-center mb-4">
                <Users className="w-6 h-6 text-purple-600" />
              </div>
              <h3 className="font-semibold text-lg text-gray-900 mb-2">
                {t('about.feature2Title')}
              </h3>
              <p className="text-gray-600">
                {t('about.feature2Desc')}
              </p>
            </CardContent>
          </Card>
          <Card className="border-0 shadow-lg hover:shadow-xl transition-shadow bg-white">
            <CardContent className="p-6">
              <div className="w-12 h-12 bg-gradient-to-br from-pink-100 to-purple-100 rounded-full flex items-center justify-center mb-4">
                <Clock className="w-6 h-6 text-green-600" />
              </div>
              <h3 className="font-semibold text-lg text-gray-900 mb-2">
                {t('about.feature3Title')}
              </h3>
              <p className="text-gray-600">
                {t('about.feature3Desc')}
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default About;
